// สำหรับตารางข้อมูลขนาดใหญ่
import Vue from 'vue';
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// แนะนำสไตล์

Vue.use(UmyUi);